import tracking from 'dibs-tracking';

function trackCollectionsImpression({ items, startIndex }) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => ({
            id: 'featured-circles',
            name: 'Featured Circles',
            creative: item.title,
            position: startIndex + index + 1,
        })),
    });
}

function trackCollectionsItemClick({ item, index }) {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'featured-circles',
                name: 'Featured Circles',
                creative: `Featured Collections : ${item.title}`,
                position: index + 1,
            },
        ],
    });
}

function trackArrowClick({ type }) {
    tracking.trackEvent({
        action: 'featured circles',
        category: 'promo interaction',
        label: `${type} arrow clicked`,
    });
}

export { trackCollectionsImpression, trackCollectionsItemClick, trackArrowClick };
